export default "__VITE_ASSET__BevB36CQ__"